module.exports = __webpack_public_path__ + "img/product-ketang-nsxl-01.1e2e227a.png";